// extracted by mini-css-extract-plugin
export default {"table-header__wrapper":"TSort_table-header__wrapper__H+exa","create__button":"TSort_create__button__tgCdu"};